import { useContext, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "./LatestBlogs.css";
import "swiper/css";
import "swiper/css/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../common/common_title/SectionTitle";
import { useNavigate } from "react-router-dom";
import { Blog, BlogById } from "../../../utils/apis/blog/Blog";
import { useEffect } from "react";
import { IDS } from "../../../utils/common";
import context from "react-bootstrap/esm/AccordionContext";
import { Context } from "../../../utils/context";

const galleryData = [
  {
    id: 1,
    title: "Live Concert Blast",
    date: "12 Jan 2026",
    desc:
      "High-energy flame and CO2 effects synchronized with live music, creating an electrifying crowd experience.",
    image: "/assets/images/newhome/latestblog/slide1.png",
  },
  {
    id: 2,
    title: "Fire Show Night",
    date: "15 Jan 2026",
    desc:
      "Amazing fire visuals and crowd lighting effects.Amazing fire visuals and crowd lighting effects.Amazing fire visuals and crowd lighting effects.",
    image: "/assets/images/newhome/latestblog/slide2.png",
  },
  {
    id: 3,
    title: "DJ Festival",
    date: "20 Jan 2026",
    desc:
      "Massive DJ night with lighting and pyro show.Massive DJ night with lighting and pyro show.Massive DJ night with lighting and pyro show.",
    image: "/assets/images/newhome/latestblog/slide3.png",
  },
];

export default function LatestBlogs() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiperRef, setSwiperRef] = useState(null);
  const handleChange = (index) => {
    setActiveIndex(index);

    if (swiperRef) {
      swiperRef.slideTo(index);
    }
  };

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [blog, setBlog] = useState([]);

  const getBlogs = async () => {
    const res = await Blog();
    if (res?.success) {
      setBlog(res.data.data);
    }
  };

  useEffect(() => {
    getBlogs();
  }, []);

  return (
    <section className="latest-blog-section">
      <div className="showcase">
        <div className="container">
          <div className="heading-wrapper">
            {" "}
            <SectionTitle
              title="Explore Our Latest Blogs"
              subtitle="See The Magic In Action  "
              className="h-title"
            />
          </div>

          {/* <div className="wrapper">
            <div
              className="left"
              onClick={() => {
                navigate("/blog/5");
              }}
            >
              <img
                src={galleryData[activeIndex].image}
                alt=""
                className="main-img"
              />
            </div>
            <div className="right">
              <h3
                className="title"
                onClick={() => {
                  navigate("/blog/5");
                }}
              >
                {galleryData[activeIndex].title}
              </h3>
              <p className="date">{galleryData[activeIndex].date}</p>
              <p className="desc">{galleryData[activeIndex].desc}</p>

              <div className="nav-btns">
                <button
                  onClick={() =>
                    handleChange(
                      activeIndex === 0
                        ? galleryData.length - 1
                        : activeIndex - 1,
                    )
                  }
                >
                  <FontAwesomeIcon icon={faAngleLeft} />
                </button>

                <button
                  onClick={() =>
                    handleChange(
                      activeIndex === galleryData.length - 1
                        ? 0
                        : activeIndex + 1,
                    )
                  }
                >
                  <FontAwesomeIcon icon={faAngleRight} />
                </button>
              </div>

              <Swiper
                onSwiper={setSwiperRef}
                spaceBetween={10}
                slidesPerView={2}
                className="thumb-slider"
              >
                {galleryData.map((item, index) => (
                  <SwiperSlide key={item.id} className="slide">
                    <img
                      src={item.image}
                      alt=""
                      className={`thumb ${
                        index === activeIndex ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(index)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div> */}

          <div className="wrapper">
            {blog.length > 0 && (
              <>
                {/* LEFT IMAGE */}
                <div
                  className="left"
                  onClick={() => navigate(`/blog/${blog[activeIndex]?.id}`)}
                >
                  <img
                    src={IDS?.IMG_URL + blog[activeIndex]?.image}
                    alt=""
                    className="main-img"
                  />
                </div>

                {/* RIGHT CONTENT */}
                <div className="right">
                  <h3
                    className="title"
                    onClick={() => navigate(`/blog/${blog[activeIndex]?.id}`)}
                  >
                    {blog[activeIndex]?.name}
                  </h3>

                  <p className="date">  {" "}
                      {new Date(blog[activeIndex]?.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}</p>

                  <p className="desc">{htmlToReactParser.parse(blog[activeIndex]?.description || "")}</p>

                  {/* <p className="desc">{htmlToReactParser.parse(blog[activeIndex]?.conclusion || "")}</p> */}
                  {/* NAV BUTTONS */}
                  <div className="nav-btns">
                    <button
                      onClick={() =>
                        handleChange(
                          activeIndex === 0 ? blog.length - 1 : activeIndex - 1,
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faAngleLeft} />
                    </button>

                    <button
                      onClick={() =>
                        handleChange(
                          activeIndex === blog.length - 1 ? 0 : activeIndex + 1,
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                  </div>

                  {/* THUMBNAIL SLIDER */}
                  <Swiper
                    onSwiper={setSwiperRef}
                    spaceBetween={10}
                    slidesPerView={2}
                    className="thumb-slider"
                  >
                    {blog.map((item, index) => (
                      <SwiperSlide key={item?.id || index}>
                        <img
                          src={IDS?.IMG_URL + item?.image}
                          alt=""
                          className={`thumb ${
                            index === activeIndex ? "active" : ""
                          }`}
                          onClick={() => setActiveIndex(index)}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
